import { render } from "./HomeTw.vue?vue&type=template&id=40abb7f6&scoped=true"
import script from "./HomeTw.vue?vue&type=script&lang=js"
export * from "./HomeTw.vue?vue&type=script&lang=js"

import "./HomeTw.vue?vue&type=style&index=0&id=40abb7f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40abb7f6"]])

export default __exports__